export const currFormat = (value: number | string) => {
	if (typeof value === 'number') {
		return new Intl.NumberFormat('en-US').format(value);
	} else {
		const number = Number(value.replace(/,/g, ''));
		if (isNaN(number)) return value;

		return new Intl.NumberFormat('en-US').format(number);
	}
};

export const removeCurrFormat = (value: string) => {
	return value.replace(/[^0-9.-]+/g, '');
};

export const numFormat = (value = 0, decimal = 0) => {
	const divider = Math.pow(10, decimal);
	return value / divider;
};
export const lblFormat = (value = 0, decimal = 0, ticker = '') => {
	const num = numFormat(value, decimal);
	return currFormat(num) + ticker;
};

export const formatThousandSeparator = (value: string) => {
	return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const removeThousandSeparator = (value: string) => {
	return value.replace(/,/g, '');
};

export const epochFormat = (value: number) => {
	return new Date(value * 1000).toUTCString().slice(0, -7) + ' UTC';
};

export const formatHash = (hash: string) => {
	if (hash.length <= 10) return hash; // Check if the hash is of valid length
	return `${hash.slice(0, 6)}...${hash.slice(-4)}`;
};
